export default __webpack_public_path__ + "static/media/icon-dental-insurance.f3396055.svg";